import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTimeout from 'react-timeout';
import { getLiveProgress } from 'helpers/Live';

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveProgress: null,
      liveInterval: null,
    };
  }

  componentDidMount() {
    const { endDate, percentWatched, startDate, setInterval } = this.props;
    if (percentWatched) return;

    const liveProgress = getLiveProgress({ startDate, endDate });
    if (liveProgress) {
      const liveInterval = setInterval(() => {
        this.setLiveProgress();
      }, 60000);
      this.setState({ liveProgress, liveInterval });
    }
  }

  setLiveProgress() {
    const { clearInterval, startDate, endDate } = this.props;
    const { liveInterval } = this.state;
    const liveProgress = getLiveProgress({ startDate, endDate });
    const nextState = { liveProgress };
    const programEnded = !liveProgress || (liveProgress && liveProgress >= 100);
    const shouldClearInterval = liveInterval && programEnded;
    if (shouldClearInterval) {
      clearInterval(liveInterval);
      nextState.liveInterval = null;
    }
    this.setState(nextState);
  }

  render() {
    const { percentWatched, theme, isContinueWatching } = this.props;
    const { liveProgress } = this.state;
    const percentWatchedUsed = percentWatched && percentWatched > 90 ? 100 : percentWatched;
    const progress = percentWatchedUsed || liveProgress;
    if (!progress && progress !== 0 && !isContinueWatching) return null;
    const progressClassSuffix = progress - (progress % 5);

    return (
      <div
        data-test="progress-bar"
        className={classNames(theme.progress, `progress-${progressClassSuffix}`)}
      >
        <div
          className={classNames(theme.done, `done-${progressClassSuffix}`)}
          style={{ width: `${progress}%` }}
        />
      </div>
    );
  }
}

ProgressBar.propTypes = {
  clearInterval: PropTypes.func.isRequired,
  endDate: PropTypes.string,
  isContinueWatching: PropTypes.bool,
  percentWatched: PropTypes.number,
  setInterval: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  theme: PropTypes.shape({}),
};

ProgressBar.defaultProps = {
  endDate: null,
  isContinueWatching: false,
  percentWatched: null,
  startDate: null,
  theme: {},
};

export default ReactTimeout(ProgressBar);
